// extracted by mini-css-extract-plugin
export default {"twolines":"AppCard_twolines__Wom+n","treelines":"AppCard_treelines__n77EV"};